<template>
    <div class="user-list">
        <status-tabs :status.sync="status" :statusList="statusList" :funcName="funcName"></status-tabs>

        <search-tool ref="searchTool" :status="status" :statusList="statusList" :funcName="funcName"
            :searchForm="searchForm" :searchList="searchList" :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields" listName="transactionDetails" :loading="loading"
            :menuAuth="menuAuth" :inputPlaceholder="inputPlaceholder" :selected="selectList.length"></search-tool>

        <div class="table" :style="{ height: `calc(${height} + 40px)` }">
            <el-table :data="tableData" ref="tableData" height="100%" row-key="id"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column align="left" label="ID" prop="id" width="50"></el-table-column>
                <el-table-column align="left" label="Express Name" prop="last_mile_name">
                </el-table-column>
                <el-table-column align="left" label="Type" prop="type"></el-table-column>
                <el-table-column align="left" label="Weight(g)" prop="weight" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="left" label="Price" prop="price">
                    <template slot-scope="scope">
                        <div v-if="scope.row.currency">
                            <span>&lt;=</span> {{ scope.row.currency
                            }}{{ scope.row.price }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Country" prop="country" show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="left" label="Created On" prop="created_at">
                </el-table-column>
                <el-table-column label="Operation" align="left" width="150" :fixed="operationFixed">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange" :funcName="funcName">
        </pagination>
        <add :addVisible.sync="addVisible" :funcName="funcName"></add>
        <edit :editVisible.sync="editVisible" :tableItem="tableItem" :funcName="funcName"></edit>
        <copy :copyVisible.sync="copyVisible" :tableItem="tableItem" :funcName="funcName"></copy>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import { mapActions } from "vuex";
import add from "./expressList/add.vue";
import edit from "./expressList/edit.vue";
import copy from "./expressList/copy.vue";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include ID、Email、Express Name",
            searchForm: {
                // weight: ["", ""],
                price: ["", ""],
                country_id: "",
                type: "",
            },
            searchForm_transfer: {
                // weight: ["", ""],
                price: ["", ""],
                country_id: "",
                type: "",
            },
            funcName: "expressList",
            selectList: [],
            addVisible: false,
            editVisible: false,
            copyVisible: false,
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
                type: {
                    label: "Type",
                    type: "select",
                    options: [],
                },
                /* weight: {
                    label: "Weight",
                    type: "range",
                }, */
                price: {
                    label: "Price",
                    type: "range",
                },
                country_id: {
                    label: "Country",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        ...mapActions(["getCountrySelect"]),
        add() {
            this.addVisible = true;
        },
        // 获取用户主体列表
        expressList(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .expressList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "edit") {
                    this.editVisible = true;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                }else if (item.funcName == "copy") {
                    this.copyVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.expressList();
            this.getCountrySelect().then((res) => {
                this.searchList[this.searchList.length-1].props.list = this.advanceSearchFields.country_id.options = res.data.map(
                    (item) => {
                        return { label: item.name_en, value: item.id.toString() };
                    }
                );
            });
             this.searchList[this.searchList.length-2].props.list = this.advanceSearchFields.type.options = [
                 {
                     label:"Regular", value: 1
                 },{
                     label:"Specify User", value: 2
                 }
             ]
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        add,
        edit,
        copy,
    },
    computed: {
        searchList() {
            return [
                /* {
                    label: this.$i18n.locale == "zh" ? "重量" : "Weight",
                    key: "weight",
                    type: "range",
                }, */
                {
                    label: this.$i18n.locale == "zh" ? "价格" : "Price",
                    key: "price",
                    type: "range",
                },
                {
                    label: "Type",
                    key: "type",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "country_id",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "国家" : "Country",
                    key: "country_id",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "country_id",
                    },
                },
                
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.user-list {
    width: 100%;
    height: 100%;
    background: #fff;

    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
